/*
 * @Author: wzc
 * @Date: 2021-10-25 10:42:36
 * @LastEditors: wzc
 * 超赛平台 base mixins
 * @LastEditTime: 2021-10-25 19:11:02
 */
export default {
  data() {
    return {
      screenMode: '', // mixtmt_h5默认screen375
      themeMode: '', // darkMode 暗夜模式
      platfromMode: '', // mixtmt_pc || 移动端[横屏: mixtmt_ipad, 竖屏: mixtmt_h5]
      isIosFlag: false,
    }
  },
  created() {
    this.isIosFlag = this.isIos()
    const { screenMode, themeMode } = this.$route.query
    this.screenMode = screenMode || ''
    this.themeMode = themeMode || ''

    console.debug('isMobiles:', this.isMobile())
    console.debug(
      'window.screen:',
      window.screen.width,
      window.screen.height,
      window.screen.availWidth,
      window.screen.availHeight
    )
    if (this.isMobile()) {
      if (this.isBigMobile()) {
        this.platfromMode = 'mixtmt_ipad'
        // 开启ipad等大屏幕移动端横竖屏监听事件
        this.watchIpadHori_el()
      } else {
        this.platfromMode = 'mixtmt_h5'
        if (!this.screenMode) {
          this.screenMode = 'screen375'
        }
      }
    } else {
      this.platfromMode = 'mixtmt_pc'
    }
    window.mixtmt_platfrom.platfromMode = this.platfromMode
  },
  methods: {
    isIos() {
      const u = navigator.userAgent
      console.debug('navigator:', u)
      if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
        //安卓手机
        // return "Android";
        return false
      } else if (u.indexOf('iPhone') > -1) {
        //苹果手机
        // return "iPhone";
        return true
      } else if (u.indexOf('iPad') > -1) {
        //iPad
        // return "iPad";
        return true
      } else if (u.indexOf('Mac OS') > -1) {
        //Mac 浏览器
        // return "Mac";
        return true
      } else if (u.indexOf('Windows Phone') > -1) {
        //winphone手机
        // return "Windows Phone";
        return false
      } else {
        return false
      }
    },
    isMobile() {
      if (
        window &&
        window.navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
      ) {
        return true // 移动端
      } else {
        return false // PC端
      }
    },
    isBigMobile() {
      //   判断是否是ipad等大屏幕移动端设备，如果是要考虑横屏展示
      if (window && window.screen.width >= 744) {
        return true
      } else {
        return false
      }
    },
    watchIpadHori_el() {
      // ipad等大屏幕移动端横竖屏监听事件
      console.debug('移动端横竖屏监听事件')
      if ('onorientationchange' in window) {
        // 谷歌 safari 等webkit 浏览器内核
        window.onorientationchange = this.resize
      } else {
        // 狐火浏览器，没有window.orientation
        window.addEventListener('resize', this.resize, false)
      }
    },
    resize(fals) {
      let orientation = window.hasOwnProperty('orientation')
        ? window.orientation
        : window.screen.orientation.angle
      console.debug(orientation)
      window.setTimeout(() => {
        if (orientation == 0 || orientation == 180) {
          console.debug('竖屏')
          this.platfromMode = 'mixtmt_h5'
        } else {
          // 等于90或者-90度横屏
          console.debug('横屏')
          this.platfromMode = 'mixtmt_ipad'
        }
      }, 10)
    },
    envOtherOption() {
      //配置项目中需要判断开发环境的 跳转链接
      let devPro = '' //pro:正式环境; dev:测试环境
      const host = window && window.location.host ? window.location.host : ''
      if (
        host.indexOf('stag-') === 0 ||
        window.location.host.indexOf('localhost.mixtmt') > -1
      ) {
        devPro = 'dev'
      } else {
        devPro = 'pro'
      }

      const dev = {
        // 测试环境
        backendManageUrl:
          'https://stag-hyper-sports-mr.mixtmt.com/#/managementPage/eventInformation', //后台管理工作台
      }

      const pro = {
        // 正式环境
        backendManageUrl:
          'https://hyper-sports-mr.mixtmt.com/#/managementPage/eventInformation',
      }

      return {
        devPro,
        dev,
        pro,
      }
    },
  },
}
